/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const FileTimeIconOutline = createIcon({
  displayName: 'FileTimeIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M20 8h-4l-4.37114e-08-8.88178e-16c-.552285-2.41411e-08-1-.447715-1-1 0 0 0 0 0 0v-4"></path>
        <path d="M6 8v-3l2.30926e-14 3.01992e-07c-1.66785e-07-1.10457.89543-2 2-2h7.172l2.05691e-08 4.39293e-12c.53039.00011328 1.03901.210901 1.414.586l2.828 2.828 -4.69231e-09-4.69089e-09c.375099.374985.585887.88361.586 1.414v11.172 0c0 1.10457-.895431 2-2 2h-10l-8.74228e-08-3.55271e-15c-1.10457-4.82823e-08-2-.895431-2-2 0 0 0 0 0 0v-1"></path>
        <path d="M7.881 11.314v1.954l1.536.936"></path>
        <rect width="10" height="10" x="3" y="8" rx="1.65684" ry="0"></rect>
      </g>
      <path fill="none" d="M0 0h24v24h-24Z"></path>
    </>
  ),
})

const FileTimeIconTwoTone = createIcon({
  displayName: 'FileTimeIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="g"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="twoToneStrokeColor"
        fill="twoToneLightColor"
        strokeLinejoin="round"
      >
        <Box
          as="path"
          strokeLinecap="round"
          strokeWidth="1.5"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          d="M6 8v-3l2.30926e-14 3.01992e-07c-1.66785e-07-1.10457.89543-2 2-2h7.172l2.05691e-08 4.39293e-12c.53039.00011328 1.03901.210901 1.414.586l2.828 2.828 -4.69231e-09-4.69089e-09c.375099.374985.585887.88361.586 1.414v11.172 0c0 1.10457-.895431 2-2 2h-10l-8.74228e-08-3.55271e-15c-1.10457-4.82823e-08-2-.895431-2-2 0 0 0 0 0 0v-1"
        ></Box>
        <Box
          as="path"
          strokeLinecap="round"
          strokeWidth="1.5"
          stroke="twoToneStrokeColor"
          fill="twoToneLightColor"
          d="M20 8h-4l-4.37114e-08-8.88178e-16c-.552285-2.41411e-08-1-.447715-1-1 0 0 0 0 0 0v-4"
        ></Box>
        <rect width="10" height="10" x="3" y="8" rx="1.65684" ry="0"></rect>
        <Box as="path" stroke="twoToneStrokeColor" fill="none" d="M7.881 11.314v1.954l1.536.936"></Box>
      </Box>
    </>
  ),
})

const FileTime: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    case 'twoTone':
      return <CustomIcon as={FileTimeIconTwoTone} {...props} />
    default:
      return <CustomIcon as={FileTimeIconOutline} {...props} />
  }
}

export default memo(FileTime)
